const backgroundDotSection = document.querySelector(".background-dot-section");
const backgroundOurGuaranteed = document.querySelector(".section-template--24278235808110__custom_liquid_FrC3jq-padding");
function createDot(ParamSection) {
  for (let i = 0; i < 20; i++) {
    const dot = document.createElement("div");
    dot.classList.add(`dot-random${Math.floor(Math.random() * 3) + 1}`);

    // Cài đặt kích thước, vị trí và màu sắc ngẫu nhiên
    const size = Math.random() * 20 + 8; // Kích thước từ 8px đến 28px
    dot.style.width = `${size}px`;
    dot.style.height = `${size}px`;
    dot.style.position = "absolute";
    dot.style.opacity = `${Math.random() + 0.4}`;
    dot.style.top = `${Math.random() * 100}vh`; // Vị trí dọc ngẫu nhiên
    dot.style.left = `-10vw`; // Vị trí ngang
    dot.style.backgroundColor = `hsl(${Math.random() * 360}, 70%, 70%)`; // Màu sắc ngẫu nhiên

    // Cài đặt hiệu ứng di chuyển
    const duration = Math.random() * 25 + 10; // Thời gian di chuyển từ 10s đến 35s
    dot.style.animationDuration = `${duration}s`;
    dot.style.animationDelay = `${Math.random() * 20}s`; // Độ trễ ngẫu nhiên
    // Thêm chấm vào phần chứa
    ParamSection.appendChild(dot);
  }
}

createDot(backgroundDotSection);
createDot(backgroundOurGuaranteed);



const content1 = "Guaranteed Quality";
const content2 = "Fast Delivery";
const content3 = "Diverse Products";
const content4 = "Surprisingly Prices";
const handwritingElement = document.querySelector(".handwriting");

const contentBanner = [content1, content2, content3,content4];
let currentTextIndex = 0;

function typeWriter(text) {
  let i = 0;
  handwritingElement.textContent = "";
  const typingInterval = setInterval(() => {
    handwritingElement.textContent += text[i];
    i++;
    if (i === text.length) {
      clearInterval(typingInterval);
      currentTextIndex = (currentTextIndex + 1) % contentBanner.length; // Quay lại text1 sau text3
      setTimeout(() => {
        typeWriter(contentBanner[currentTextIndex]);
      }, 500);
    }
  }, 100);
}

typeWriter(contentBanner[currentTextIndex]);
